module.exports = __webpack_public_path__ + "img/coinspot-v-sml.479dbedf.png";